import { Dimensions } from '@features/virtual-tour/types';

export const imageResize = (
    { width: naturalWidth, height: naturalHeight }: Dimensions,
    { width: viewportWidth, height: viewportHeight }: Dimensions,
): Dimensions | null => {
    const imageRatio = naturalWidth / naturalHeight;
    const viewportRatio = viewportWidth / viewportHeight;
    if (isNaN(imageRatio) || isNaN(viewportRatio) || imageRatio * viewportRatio === 0) return null;

    const dimensions: Dimensions =
        imageRatio < viewportRatio
            ? { width: viewportWidth, height: Math.round(viewportWidth / imageRatio) }
            : { width: Math.round(viewportHeight * imageRatio), height: viewportHeight };

    return dimensions;
};
